import React, { useEffect, useState } from "react";
import { string, object, number, array } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import FocusedCard from "../../atoms/FocusedCard";
import { getSlug, getCollectionName } from "../../utils/utils";
import RightArrowButton from "../../atoms/icons/right-arrow-button";
import LeftArrowButton from "../../atoms/icons/left-arrow-button";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import ScrollSnap from "../../atoms/ScrollSnap";

import "./sliderFocusedCard.m.css";

const SliderFocusedCard = ({ collection, sections, domainSlug, publisherAttributes }) => {
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const [showCarousel, setShowCarousel] = useState(false);
  const [deviceType, setDeviceType] = useState(true);
  const collectionItems = collection.items.filter((item) => item.type === "collection");
  const collectionOfCollectionsType = get(collection, ["associated-metadata", "collection_of_collections"], false);
  const showTag = get(collection, ["associated-metadata", "show_tag_name"], false);
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const stories = collection.items.filter((item) => item.type === "story").map((item) => item.story);

  if (!collectionOfCollectionsType && !stories.length) {
    return null;
  }

  if (collectionOfCollectionsType && !collectionItems.length) {
    return null;
  }

  const collectionOfCollectionsSlides =
    collectionItems &&
    collectionItems.slice(0, 10).map((item) => {
      const story = item.items.length > 0 ? item.items.find((story) => (story.type = story)) : null;

      if (!story) {
        return null;
      }

      return (
        <FocusedCard
          key={story.story ? story.story.id : story.id}
          story={story.story ? story.story : story}
          styleName="card"
          updatedFont={true}
          publisherLang={publisherAttributes.lang}
          showTag={showTag}
        />
      );
    });

  const storiesSlides =
    stories.length > 0 &&
    stories
      .slice(0, 10)
      .map((story) => (
        <FocusedCard
          key={story.id}
          story={story}
          styleName="card"
          updatedFont={true}
          publisherLang={publisherAttributes.lang}
          showTag={showTag}
        />
      ));

  const slides = collectionOfCollectionsType ? collectionOfCollectionsSlides : storiesSlides;

  useEffect(() => {
    if (global.deviceWidth > 1263) {
      setDeviceType("desktop");
      setShowCarousel(slides.length > 4);
    } else if (global.deviceWidth > 875 && global.deviceWidth < 1264) {
      setDeviceType("tab");
      setShowCarousel(slides.length > 3);
    } else if (global.deviceWidth < 876) {
      setDeviceType("mobile");
      setShowCarousel(slides.length > 1);
    }
  }, []);

  return (
    <div styleName="base" className="slider-focused-card" data-testid="slider-story-cards">
      <div styleName="carousel-wrapper">
        {showCollectionName && collection.name && (
          <CollectionTitleWithArrow
            collectionName={collectionName}
            collectionSlug={collectionSlug}
            updatedFont={true}
          />
        )}
        {showCarousel ? (
          <ScrollSnap
            leftArrow={<LeftArrowButton color="#121212" />}
            rightArrow={<RightArrowButton color="#121212" />}
            src="SliderFocusedCard"
            isIndicator={deviceType === "mobile"}
            deviceType={deviceType}
            isArrow={deviceType !== "mobile"}
          >
            {slides}
          </ScrollSnap>
        ) : (
          <div styleName="story-cards">{slides}</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

SliderFocusedCard.propTypes = {
  accentColor: string,
  collection: object,
  numberOfCardsInViewDesktop: number,
  numberOfCardsInViewTablet: number,
  numberOfCardsInViewMobile: number,
  sections: array,
  publisherAttributes: object,
  domainSlug: string,
};

export default connect(mapStateToProps, null)(SliderFocusedCard);
